<div class="auth-layout">
  <div class="auth-layout__header">
    <div class="auth-layout__logo">
      <a [routerLink]="['/']">
        <img src="assets/img/logo.svg" alt="{{ 'app.title' | transloco }}" />
      </a>
    </div>
  </div>
  <div class="auth-layout__content">
    <div class="auth-layout__card">
      <router-outlet></router-outlet>
    </div>
  </div>
  <div class="auth-layout__footer">
    <p>&copy; {{ currentYear }} {{ 'app.legalName' | transloco }}. {{ 'footer.allRightsReserved' | transloco }}</p>
  </div>
</div>
